<!-- Nested “Edit NOL Details” overlay (outside main .modal-body) -->
@if (ctx.showNestedModal) {
<div class="nested-modal-overlay">
  <div class="nested-modal-container">
    <div class="modal-header tax-attributes-nested-modal-header">
      <h3 class="modal-title">Edit NOL Details for {{ ctx.scheduled_year }}</h3>
      <div class="header-actions">
        <i class="fa"
           [ngClass]="{'fa-plus-square-o': ctx.nestedMinimise, 'fa-minus-square-o': !ctx.nestedMinimise}"
           style="cursor: pointer;"
           (click)="ctx.toggleNestedMinimise($event)"
           title="Minimise"></i>
        <i class="fa fa-times"
           style="cursor: pointer;"
           (click)="ctx.closeNestedModal()"
           title="Close"></i>
      </div>
    </div>

    <div class="modal-body" [hidden]="ctx.nestedMinimise">
      <div class="form-horizontal">
        <div style="padding-left: 17px; margin-bottom: 20px;">
          <label style="padding-right: 92px;">Transaction Type :</label>
          <label>
            <input type="radio" name="transType" [(ngModel)]="ctx.transValue" value="1" [disabled]="ctx.disRegTransType"/>
            Regular
          </label>
          <label style="padding-left: 10px;">
            <input type="radio" name="transType" [(ngModel)]="ctx.transValue" value="2" [disabled]="ctx.disQARTransType"/>
            QAR
          </label>
        </div>

        <div class="row" style="margin-bottom: 20px;">
          <div class="col-md-2 rightText noWrap"><label>Available Amount :</label></div>
          @if (ctx.taxAttrib_year_data?.TAX_YEAR != null) {
<div class="col-md-4">
            {{ ctx.taxAttrib_year_data?.AVAILABLE_AMT | numberWithCommas }}
          </div>
}
          @if (ctx.taxAttrib_year_data?.TAX_YEAR == null) {
<div class="col-md-4">
            {{ ctx.taxAttrib_year_data?.DUMMY_AVAILABLE_AMT | numberWithCommas }}
          </div>
}
          @if (ctx.activeTab != 74) {
<div class="col-md-3 rightText noWrap">
            <label>382 Limitation Amount :</label>
          </div>
}
          @if (ctx.activeTab != 74 && ctx.taxAttrib_year_data?.TAX_YEAR != null) {
<div class="col-md-2">
            {{ ctx.taxAttrib_year_data?.ROLLING_ANNUAL_LIMIT | numberWithCommas }}
          </div>
}
          @if (ctx.activeTab != 74 && ctx.taxAttrib_year_data?.TAX_YEAR == null) {
<div class="col-md-2">
            {{ ctx.taxAttrib_year_data?.DUMMY_ANNUAL_LIMIT | numberWithCommas }}
          </div>
}
        </div>

        <div style="padding-left: 17px; margin-bottom: 20px;">
          <label style="padding-right: 128px;">Expire Year :</label>
          @if (ctx.taxAttrib_year_data?.TAX_YEAR != null) {
<input type="text"
                 class="form-control input-md"
                 style="text-align: right; display: inline-block; width: 200px"
                 maxlength="4"
                 inputmode="numeric"
                 onlyDigits
                 [(ngModel)]="ctx.taxAttrib_year_data.EXPIRE_YEAR"
                >
}
          @if (ctx.taxAttrib_year_data?.TAX_YEAR == null) {
<input type="text"
                 class="form-control input-md"
                 style="text-align: right; display: inline-block; width: 200px"
                 maxlength="4"
                 inputmode="numeric"
                 onlyDigits
                 [(ngModel)]="ctx.taxAttrib_year_data.DUMMY_EXPIRE_YEAR"
                >
}
        </div>

        <div class="table-container">
          <table class="table table-bordered form-inline customTable custom-table">
            <thead>
              <tr>
                <th>Tax Attributes</th>
                <th>Generated Amount</th>
                <th>Comment</th>
              </tr>
            </thead>
            <tbody>
              @for (row of ctx.allTaxAttribList; track $index; let i = $index) {
<tr class="table1">
                <td class="col-md-2">{{ row.TRANS_TYPE_DESC }}</td>
                <td class="col-md-2">
                  <input type="text"
                         class="form-control input-md numText"
                         style="text-align: right; width: 85%;"
                         [(ngModel)]="row.AMOUNT"
                         (ngModelChange)="ctx.changeTAAmount(row)">
                </td>
                <td class="col-md-6">
                  <textarea class="form-control custom-textbox"
                            [(ngModel)]="row.DETAILREASON"
                            style="height: 50px; width:98%; overflow:scroll; resize:vertical;"
                            maxlength="3998"
                            (ngModelChange)="ctx.changeTAAmount(row)"></textarea>
                  <label style="font-weight: normal;font-size:x-small;color: gray;">Max length 4000</label>
                </td>
              </tr>
}
            </tbody>
          </table>
        </div>

        <div class="genUtilTable" style="margin-top: 30px;">
          <table class="table table-bordered form-inline customTable custom-table">
            <thead>
              <tr>
                <th>Year</th>
                <th>Transaction Type</th>
                <th>Expire Year</th>
                <th>Available Amount</th>
                <th>Utilized Amount</th>
                <th>Pre Acquisition Amount</th>
              </tr>
            </thead>
            <tbody>
              @if (ctx.taxAttributeYearsData.length === 0) {
<tr>
                <td class="loading-table" colspan="6">
                  <div style="margin-top:40px"><b>No Existing Records</b></div>
                </td>
              </tr>
}
              @for (row of ctx.taxAttributeYearsData; track $index; let i = $index) {
<tr class="table1">
                <td>{{ row.TAX_YEAR }}</td>
                <td>{{ row.TRANS_TYPE }}</td>
                <td>{{ row.EXPIRE_YEAR }}</td>
                <td [ngClass]="{'color-red': row.AVAILABLE_AMT < 0}">{{ row.AVAILABLE_AMT | numberWithCommas }}</td>
                <td class="col-md-2">
                  <input type="text"
                         class="form-control input-md numText"
                         style="text-align: right; width: 85%;"
                         [(ngModel)]="row.AMOUNT"
                         (ngModelChange)="ctx.changeTAAmount(row)">
                </td>
                <td class="col-md-2">
                  <input type="text"
                         class="form-control input-md numText"
                         style="text-align: right; width: 85%;"
                         [(ngModel)]="row.PREACQUI_AMT"
                         (ngModelChange)="ctx.changeTAAmount(row)">
                </td>
              </tr>
}
            </tbody>
          </table>
        </div>

        <div class="genUtilTable" style="margin-top: 30px;">
          <table class="table table-bordered form-inline customTable custom-table">
            <thead>
              <tr>
                <th>Gen/Util</th>
                <th>Regular/QAR</th>
                @if (ctx.activeTab != 73) {
<th>NOL_REG</th>
}
                @if (ctx.activeTab == 73) {
<th>NOL_382</th>
}
              </tr>
            </thead>
            <tbody>
              @if (ctx.taxAttribEntityTxnData.length === 0) {
<tr>
                <td class="loading-table" colspan="3">
                  <div style="margin-top:40px"><b>No Existing Records</b></div>
                </td>
              </tr>
}
              @for (row of ctx.taxAttribEntityTxnData; track $index; let i = $index) {
<tr class="table1">
                <td>{{ row.UTIL_TYPE }}</td>
                <td>{{ row.TRANS_TYPE }}</td>
                <td [ngClass]="{'color-red': row.AMOUNT < 0}">{{ row.AMOUNT | numberWithCommas }}</td>
              </tr>
}
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="modal-footer" [hidden]="ctx.nestedMinimise">
      <button class="save-button"
              type="button"
              [disabled]="ctx.isSaveClicked"
              (click)="ctx.saveNestedModal()">
        @if (ctx.crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
      </button>
      <button class="reset-button"
              type="button"
              (click)="ctx.resetNestedModal()">Reset</button>
      <button class="cancel-button"
              type="button"
              (click)="ctx.closeNestedModal()">Cancel</button>
    </div>
  </div>
</div>
}
